export class GetUserNameResult {
  public success: boolean;
  public error: boolean;
  public errorMessage: string;
  public userName: string;

  constructor(  success: boolean = false,
                error: boolean = false,
                errorMessage: string = '',
                userName: string = ''
              )
            {
                this.success = success;
                this.error = error;
                this.errorMessage = errorMessage;
                this.userName = userName;
            };
}
